import React from 'react'
import { Button, Input, Option, Select } from '@material-tailwind/react'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
const BlogForm = ({blogTitle,setBlogTitle,blogContent,setBlogContent,coverImage,setCoverImage,bannerImage,setBannerImage,blogContentTwo,setBlogContentTwo,blogImageOne,setBlogImageOne,blogImageTwo,setBlogImageTwo,blogWriter,setBlogWriter,addCoverImage,addBannerImage,addImageOne,addImageTwo,addBlog}) => {
  return (
    <div className='ml-[20rem] overflow-y-scroll'>
        <div>
        <h3 className='font-[NeueBold] py-2 text-[2rem]' >Add Blog</h3>
        <div className='my-3 py-3 px-6 bg-white rounded-lg'>
        <h3 className='font-[NeueMedium] my-2 text-[1rem]' >Add Blog Details</h3>
        <div>
        <div className='my-6' >
            <Input value={blogTitle} onChange={(e)=>setBlogTitle(e.target.value)} label='Enter Blog Name' />
            </div>
            <div className='my-6'>
            <CKEditor
                    editor={ ClassicEditor }
                    data={blogContent}
                    onReady={ editor => {
                        // You can store the "editor" and use when it is needed.
                        console.log( 'Editor is ready to use!', editor );
                    } }
                    onChange={ ( event, editor ) => {
                      
                        const data = editor.getData();
                        setBlogContent(data)
                        console.log( { event, editor, data } );
                    } }
                    onBlur={ ( event, editor ) => {
                        console.log( 'Blur.', editor );
                    } }
                    onFocus={ ( event, editor ) => {
                        console.log( 'Focus.', editor );
                    } }
                />
                </div>
                <div className='my-6'>
            <CKEditor
                    editor={ ClassicEditor }
                    data={blogContentTwo}
                    onReady={ editor => {
                        // You can store the "editor" and use when it is needed.
                        console.log( 'Editor is ready to use!', editor );
                    } }
                    onChange={ ( event, editor ) => {
                      
                        const data = editor.getData();
                        setBlogContentTwo(data)
                        console.log( { event, editor, data } );
                    } }
                    onBlur={ ( event, editor ) => {
                        console.log( 'Blur.', editor );
                    } }
                    onFocus={ ( event, editor ) => {
                        console.log( 'Focus.', editor );
                    } }
                />
                </div>
        </div>
        
        </div>

        </div>
        <div className='mr-3 bg-white px-6 py-6  rounded-md my-8' >
        <h3 className='mb-2 font-[NeueMedium]' >Blog Cover Image</h3>
        <div>
        <div>
                     <form  onSubmit={addCoverImage} className='form flex items-center justify-center flex-col my-6 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Image</Button>
      </form>
      
                </div>
                <div className='flex items-center justify-start gap-6' >
                   
                         { coverImage?.length !== 0 &&  <div className='flex items-center justify-start gap-6' >
                                <img className='w-[200px] h-[200px]' src={coverImage} />
                            </div>}
                       
                </div>
        </div>
       
        </div>
        <div className='mr-3 bg-white px-6 py-6  rounded-md my-8' >
        <h3 className='mb-2 font-[NeueMedium]' >Blog Banner Image</h3>
        <div>
        <div>
                     <form  onSubmit={addBannerImage} className='form flex items-center justify-center flex-col my-6 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Image</Button>
      </form>
      
                </div>
                <div className='flex items-center justify-start gap-6' >
                   
                         { bannerImage?.length !== 0 &&  <div className='flex items-center justify-start gap-6' >
                                <img className='w-[200px] h-[200px]' src={bannerImage} />
                            </div>}
                       
                </div>
        </div>
       
        </div>
        <div className='mr-3 bg-white px-6 py-6  rounded-md my-8' >
        <h3 className='mb-2 font-[NeueMedium]' >Blog Image One</h3>
        <div>
        <div>
                     <form  onSubmit={addImageOne} className='form flex items-center justify-center flex-col my-6 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Image</Button>
      </form>
      
                </div>
                <div className='flex items-center justify-start gap-6' >
                   
                         { blogImageOne?.length !== 0 &&  <div className='flex items-center justify-start gap-6' >
                                <img className='w-[200px] h-[200px]' src={blogImageOne} />
                            </div>}
                       
                </div>
        </div>
       
        </div>
        <div className='mr-3 bg-white px-6 py-6  rounded-md my-8' >
        <h3 className='mb-2 font-[NeueMedium]' >Blog Image One</h3>
        <div>
        <div>
                     <form  onSubmit={addImageTwo} className='form flex items-center justify-center flex-col my-6 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Image</Button>
      </form>
      
                </div>
                <div className='flex items-center justify-start gap-6' >
                   
                         { blogImageTwo?.length !== 0 &&  <div className='flex items-center justify-start gap-6' >
                                <img className='w-[200px] h-[200px]' src={blogImageTwo} />
                            </div>}
                       
                </div>
        </div>
       
        </div>
        <div className='flex items-center mr-3 justify-end my-3' >
            <Button onClick={addBlog} >Submit</Button>
        </div>
    </div>
  )
}

export default BlogForm